<template>
      <div class="staffCreate">
        <v-breadcrumbs>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
            >Home</v-breadcrumbs-item
          >
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :exact="true" :to="{ name: 'staff', params: {} }">
          Staff
          </v-breadcrumbs-item>
          <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
          <v-breadcrumbs-item :to="{ name: 'staffCreate', params: {} }">
            Create Staff
          </v-breadcrumbs-item>
        </v-breadcrumbs>

        <v-card>
          <v-card-title>Create Staff</v-card-title>
          <v-card-text>
            <staff-form></staff-form>
          </v-card-text>
        </v-card>
      </div>
    </template>
    <script>
    import StaffForm from './StaffForm.vue';

    export default {
      name: 'staff',
      components: {
        StaffForm
      },
      created() {
        this.$emit("showParent", false);
      }
    }
    </script>
    